import React from 'react';
import Header from '../start-page/Header';
import Footer from '../start-page/Footer';
import styles from './ContactPage.module.css';
import Banner from './Banner';
import CtaSection from '../start-page/CtaSection';
const ContactPage: React.FC = () => {
    return (
        <div className={styles.contactPage}>
            <Header />
            <Banner />
            <CtaSection />
            <Footer />
        </div>
    );
};

export default ContactPage;
